import { Team } from '@/types'

const environment = import.meta.env.VITE_BUILD_ENV || 'uat'
const disableMatchEdit = import.meta.env.VITE_DISABLE_MATCH_EDIT || 'false'

export const isProd = environment === 'prod'
export const isUAT = environment === 'uat'
export const isDev = environment !== 'prod' && environment !== 'uat'

export const isLocal = import.meta.env.DEV

export const DEV_PROXY_PORT = Number(import.meta.env.VITE_DEV_PROXY_PORT) || 8787
export const DEV_PROXY_URL = import.meta.env.VITE_DEV_PROXY_URL || `http://localhost:${DEV_PROXY_PORT}/`

export const isDisableMatchEdit = disableMatchEdit === 'true'

export const PHONE_NUMBER = '+1 (979) 399-7929'
export const SMS_PHONE_NUMBER = 'SMS:+19793997929'

export const gameNumbers: (keyof Team)[] = ['game1', 'game2', 'game3', 'game4', 'game5']

export const FIREBASE_CONFIG = isProd
  ? {
      apiKey: 'AIzaSyCmBKXs8WJu4H39opxo3AKZgXmETjrHcOs',
      authDomain: 'dupr-gg.firebaseapp.com',
      projectId: 'dupr-gg',
      storageBucket: 'dupr-gg.appspot.com',
      messagingSenderId: '915461001618',
      appId: '1:915461001618:web:8a0c2a7461efc64878314b',
      measurementId: 'G-PNQ9RP16SS',
    }
  : {
      apiKey: 'AIzaSyBo74wYGmzRNkUZGEEx7XESY9VVk64bbik',
      authDomain: 'dupr-dev.firebaseapp.com',
      projectId: 'dupr-dev',
      storageBucket: 'dupr-dev.appspot.com',
      messagingSenderId: '612467506905',
      appId: '1:612467506905:web:f935f4783cd15cad6448c8',
      measurementId: 'G-4CT01KQEJ7',
    }

// API base URL for DEPLOYED builds (local `vite dev` is handled by the isLocal branch).
// - prod build -> prod API
// - every other deployed build (uat AND Amplify PR-branch previews, where VITE_BUILD_ENV is a
//   non-prod value) -> the UAT API, called cross-origin.
//
// Previews MUST use this absolute URL. The old `isDev ? '/api/'` relative path only resolved via
// the local vite dev proxy; on Amplify there is no such proxy, so `/api/...` hit the preview's own
// origin and Amplify returned the SPA's index.html (HTML), which broke /auth/v1.0/login. The UAT
// backend already allows `https://*.amplifyapp.com` via CORS (see server application.yml), so the
// cross-origin preview calls are permitted without a per-branch deployment.
export const BASE_API_URL = isLocal
  ? DEV_PROXY_URL
  : isProd
    ? // Prod API moved to api.dupr.com so it is same-site with the web app (dashboard.dupr.com),
      // which is what lets the HttpOnly session cookie be first-party.
      'https://api.dupr.com/'
    : 'https://api.uat.dupr.gg/'

export const BASE_APP_URL = isProd ? 'https://dashboard.dupr.com' : 'https://uat.dupr.gg'

// The first-party session now lives in HttpOnly cookies, so the SPA never holds the real access
// token. This non-secret marker stands in for it wherever the app only asks "is there a session?"
// (route guards, the redux `auth.token` gate). It is never sent as a bearer — cookies authenticate.
export const COOKIE_SESSION = 'cookie-session'

/**
 * The strong second factors this web client can actually perform, sent as `X-DUPR-Client-Capabilities`
 * on the login/2FA calls. The server offers the intersection of (what the user enrolled) and (what
 * this client can do); a browser can run a WebAuthn ceremony and render a TOTP QR/code box, so it
 * advertises both. Advisory only — the server never widens what it accepts based on it. Lives here
 * (not in services/auth) so httpService can read it without an import cycle.
 */
export const MFA_CLIENT_CAPABILITIES = 'totp,webauthn'

export const SITE_KEY = 'MTPublic-KLhCVVjfs'

export const BRAZE_API_KEY = isProd ? '52e23b31-56cd-4a7e-aee1-fe585866ac64' : '45ee8929-e53f-4cba-ac37-0783915fbc9b'
export const BRAZE_API_URL = isProd ? 'sdk.iad-06.braze.com' : 'sdk.iad-06.braze.com'

export const CHAT_API_KEY = isProd ? 'qgzmxzx58rsr' : isUAT ? '329fmzvycq2u' : 'jyhkjsh6xuun'
export const GOOGLEMAP_API_KEY = isProd
  ? 'AIzaSyC4LyHL9xQl2hwKfgqJdqhUOx_XXwCugyQ'
  : 'AIzaSyC-eq3rFbKbawMtlMltOlvTvyJSXubQk0U'

export const regexWeb =
  /(((H|h)(T|t)(T|t)(P|p)(S|s)|(F|f)(T|t)(P|p)|(H|h)(T|t)(T|t)(P|p)):\/\/)?([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/g

export const regexHashTag = /\B(#[a-zA-Z0-9_]+\b)(?!;)/g

export const regexGetTagInContent = /(@\[[\w\s]+\])(\()(\w+)(\))/g

export const MIN_PASSWORD_LENGTH = 6 // number
export const MAX_PASSWORD_LENGTH = 40 // number
export const MAX_PHONE_LENGTH = 16 // number
export const MAX_NAME_LENGTH = 50 // number
export const MAX_FULL_NAME_LENGTH = 101 // number

export const OFFSET = 0
export const LIMIT = 10
export const SORT_ORDER = 'DESC'
export const SORT_PARAMETER = 'MATCH_DATE'

export const CLUB_VIEW = 'CLUB::VIEW'
export const CLUB_NAME_VIEW = 'CLUB_NAME::VIEW'
export const CLUB_NAME_MODIFY = 'CLUB_NAME::MODIFY'

export const CLUB_LOGO_VIEW = 'CLUB_LOGO::VIEW'
export const CLUB_LOGO_MODIFY = 'CLUB_LOGO::MODIFY'

export const CLUB_DOWNLOAD = 'CLUB::DOWNLOAD'
export const CLUB_ADD = 'CLUB::ADD'
export const CLUB_MODIFY = 'CLUB::MODIFY'
export const CLUB_DELETE = 'CLUB::DELETE'

export const CLUB_CONTACT_INFO_VIEW = 'CLUB_CONTACT_INFO::VIEW'
export const CLUB_CONTACT_INFO_MODIFY = 'CLUB_CONTACT_INFO::MODIFY'

export const CLUB_DIRECTOR_CONTACT_INFO_MODIFY = 'CLUB_DIRECTOR_CONTACT_INFO::MODIFY'
export const CLUB_ASSISTANT_DIRECTOR_ADD = 'CLUB_ASSISTANT_DIRECTOR::ADD'
export const CLUB_ASSISTANT_DIRECTOR_DELETE = 'CLUB_ASSISTANT_DIRECTOR::DELETE'

export const CLUB_MEMBERS_ADD = 'CLUB_MEMBERS::ADD'
export const CLUB_MEMBERS_DELETE = 'CLUB_MEMBERS::DELETE'
export const CLUB_MEMBER_INFO_VIEW = 'CLUB_MEMBER_INFO::VIEW'

export const CLUB_ORGANIZER_ADD = 'CLUB_ORGANIZER::ADD'
export const CLUB_ORGANIZER_DELETE = 'CLUB_ORGANIZER::DELETE'
export const CLUB_ORGANIZER_CONTACT_INFO_MODIFY = 'CLUB_ORGANIZER_CONTACT_INFO::MODIFY'

export const CLUB_MATCH_VIEW = 'CLUB_MATCH::VIEW'
export const CLUB_MATCH_ADD = 'CLUB_MATCH::ADD'

export const EVENT_ADD = 'EVENT::ADD'
export const EVENT_MODIFY = 'EVENT::MODIFY'

export const BRACKET_ADD = 'BRACKET::ADD'
export const BRACKET_MODIFY = 'BRACKET::MODIFY'

export const MIN_AGE = 13 // years
export const MAX_AGE = 105 // years

export const FLEX_ELIMINATION = 'FLEX'
export const MATCH_SOURCE_LEAGUE = 'LEAGUE'
export const MATCH_SOURCE_DUPR = 'DUPR'
export const MATCH_SOURCE_CLUB = 'CLUB'

// A match can only be edited/deleted from the club UI when it originated in the
// club (source CLUB). Matches with any other explicit source (PARTNER, LEAGUE,
// TOURNAMENT, etc.) were uploaded on an external platform and must be managed there.
export const isExternallyManagedMatch = (matchSource?: string | null): boolean =>
  !!matchSource && matchSource !== MATCH_SOURCE_CLUB

export const DESCRIPTION_MAX_LENGTH = 4500 // characters
export const DESCRIPTION_MIN_LENGTH = 10 // characters
export const TITLE_MAX_LENGTH = 150 // characters

export const MIN_SCORE_POINTS = 6 // number
export const MIN_SCORE_POINTS_2 = 0 // number
export const PHONE_NO_LENGTH = 17 // number
export const MIN_DIGIT_AFTER_DECIMAL = 2 // number
export const MAX_SCORE_POINTS = 99 // number
export const MAX_SCORE_ERROR = `Maximum score cannot exceed ${MAX_SCORE_POINTS} points. `
export const MIN_SCORE_ERROR = `The winner of the first game must score a minimum of ${MIN_SCORE_POINTS} points. `
export const MATCH_TIE_ERROR = 'Either team must be a winner'
export const TEAMS_SCORE_ERROR = 'Atleast one team must score more than 0'

export const MAX_PRICE_VALUE = 99999.99

export const MIN_RATING = 2 // number
export const MAX_RATING = 8 // number

export const MIN_COURTS = 1 // number
export const MAX_COURTS = 8 // number

export const TOTAL_BRACKETS = 40 // number
export const TOTAL_WAITLIST = 50 // number
export const MIN_TEAMS = 2 // number
export const TOTAL_TEAMS = 100 // number

export const MAX_GAMES = 5 // number
export const IMAGE_MAX_SIZE = 50000000 // bytes
export const FILE_MAX_SIZE = 4000000 // bytes

export const SCROLLING_HEIGHT_ABS_ERROR = 50 // pixel
export const SCROLLING_THROTTLING_DURATION = 500 // ms

export const LOCAL_EMAIL_RESEND_END_TIME = 'emailResendTime'
export const LOCAL_EMAIL_RESEND_COUNT = 'emailResendCount'

export const waterfallDiagramTemplateLink = 'https://dupr-dev.s3.amazonaws.com/documents/Blank+Waterfall+Diagram.pdf'

export const MarketingAssetsLink = 'https://www.dupr.com/club-resources'

export const CONTACT_SUPPORT = 'https://dupr.zendesk.com/hc/en-us/requests/new'

export const SUPPORT_DIRECT = 'https://dupr.zendesk.com/hc/en-us'
